// Yield to the browser long enough for a pending UI update to be painted
// before the caller starts heavy synchronous work or triggers a navigation.
// Two animation frames cover the layout/paint cycle on most engines.
export const waitForPaint = (): Promise<void> =>
  new Promise<void>((resolve) => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => resolve());
    });
  });
